// extracted by mini-css-extract-plugin
var _1 = "Lp4U8";
var _2 = "PWSiL";
var _3 = "eRcBe";
var _4 = "tR8G4";
var _5 = "atedn";
var _6 = "MxmBo";
var _7 = "H5uVa";
export { _1 as "checkbox", _2 as "icon", _3 as "input", _4 as "is-checked", _5 as "is-disabled", _6 as "label", _7 as "shape" }
